import {
  GET_UNMAPPED_POSITIONS,
  GET_UNMAPPED_POSITIONS_SUCCESS,
  GET_UNMAPPED_POSITIONS_FAIL,
  GET_UNMATCHED_CLASSIFICATIONS,
  GET_UNMATCHED_CLASSIFICATIONS_SUCCESS,
  GET_UNMATCHED_CLASSIFICATIONS_FAIL,
  GET_NO_CLASSIFICATION_POSITIONS,
  GET_NO_CLASSIFICATION_POSITIONS_SUCCESS,
  GET_NO_CLASSIFICATION_POSITIONS_FAIL,
  GET_CLASSIFICATIONS_LOOKUP,
  GET_CLASSIFICATIONS_LOOKUP_SUCCESS,
  GET_CLASSIFICATIONS_LOOKUP_FAIL,
  PROPOSE_POSITION_MAPPING,
  PROPOSE_POSITION_MAPPING_SUCCESS,
  PROPOSE_POSITION_MAPPING_FAIL,
  GET_PENDING_POSITION_MAPPINGS,
  GET_PENDING_POSITION_MAPPINGS_SUCCESS,
  GET_PENDING_POSITION_MAPPINGS_FAIL,
  DECIDE_POSITION_MAPPING,
  DECIDE_POSITION_MAPPING_SUCCESS,
  DECIDE_POSITION_MAPPING_FAIL,
  GET_MY_MAPPING_HISTORY,
  GET_MY_MAPPING_HISTORY_SUCCESS,
  GET_MY_MAPPING_HISTORY_FAIL,
} from "./actionTypes";

export const getUnmappedPositions = () => ({
  type: GET_UNMAPPED_POSITIONS,
});
export const getUnmappedPositionsSuccess = (data) => ({
  type: GET_UNMAPPED_POSITIONS_SUCCESS,
  payload: data,
});
export const getUnmappedPositionsFail = (error) => ({
  type: GET_UNMAPPED_POSITIONS_FAIL,
  payload: error,
});

export const getUnmatchedClassifications = () => ({
  type: GET_UNMATCHED_CLASSIFICATIONS,
});
export const getUnmatchedClassificationsSuccess = (data) => ({
  type: GET_UNMATCHED_CLASSIFICATIONS_SUCCESS,
  payload: data,
});
export const getUnmatchedClassificationsFail = (error) => ({
  type: GET_UNMATCHED_CLASSIFICATIONS_FAIL,
  payload: error,
});

export const getPositionsWithNoClassification = () => ({
  type: GET_NO_CLASSIFICATION_POSITIONS,
});
export const getPositionsWithNoClassificationSuccess = (data) => ({
  type: GET_NO_CLASSIFICATION_POSITIONS_SUCCESS,
  payload: data,
});
export const getPositionsWithNoClassificationFail = (error) => ({
  type: GET_NO_CLASSIFICATION_POSITIONS_FAIL,
  payload: error,
});

export const getClassificationsLookup = () => ({
  type: GET_CLASSIFICATIONS_LOOKUP,
});
export const getClassificationsLookupSuccess = (data) => ({
  type: GET_CLASSIFICATIONS_LOOKUP_SUCCESS,
  payload: data,
});
export const getClassificationsLookupFail = (error) => ({
  type: GET_CLASSIFICATIONS_LOOKUP_FAIL,
  payload: error,
});

export const proposePositionMapping = (payload) => ({
  type: PROPOSE_POSITION_MAPPING,
  payload,
});
export const proposePositionMappingSuccess = (response) => ({
  type: PROPOSE_POSITION_MAPPING_SUCCESS,
  payload: response,
});
export const proposePositionMappingFail = (error) => ({
  type: PROPOSE_POSITION_MAPPING_FAIL,
  payload: error,
});

export const getPendingPositionMappings = () => ({
  type: GET_PENDING_POSITION_MAPPINGS,
});
export const getPendingPositionMappingsSuccess = (data) => ({
  type: GET_PENDING_POSITION_MAPPINGS_SUCCESS,
  payload: data,
});
export const getPendingPositionMappingsFail = (error) => ({
  type: GET_PENDING_POSITION_MAPPINGS_FAIL,
  payload: error,
});

export const decidePositionMapping = (id, payload) => ({
  type: DECIDE_POSITION_MAPPING,
  payload: { id, ...payload },
});
export const decidePositionMappingSuccess = (response) => ({
  type: DECIDE_POSITION_MAPPING_SUCCESS,
  payload: response,
});
export const decidePositionMappingFail = (error) => ({
  type: DECIDE_POSITION_MAPPING_FAIL,
  payload: error,
});

export const getMyMappingHistory = () => ({
  type: GET_MY_MAPPING_HISTORY,
});
export const getMyMappingHistorySuccess = (data) => ({
  type: GET_MY_MAPPING_HISTORY_SUCCESS,
  payload: data,
});
export const getMyMappingHistoryFail = (error) => ({
  type: GET_MY_MAPPING_HISTORY_FAIL,
  payload: error,
});
